module.exports = __webpack_public_path__ + "img/xgr.93029f7f.png";